import script from "./pf-esic-details.vue?vue&type=script&setup=true&lang=js"
export * from "./pf-esic-details.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__